// m for moment

export const formatFullDateTime = (m) => `${m.format('LLL')} ${m.format('LT')}`

export const formatFullDateTimeWithDay = (m) =>
  `${m.format('dddd, MMMM D')}, ${m.format('LT')}`

export default 0
